// extracted by mini-css-extract-plugin
export default {"result":"style-module--result--ec247","highlight":"style-module--highlight--637ff"};